export default defineNuxtRouteMiddleware((to) => {
  const { isAuthenticated } = useAuth()

  console.log(isAuthenticated.value, to.fullPath)

  if (!isAuthenticated.value && to.path !== '/login' && to.path !== '/register') {
    // 保存用户原本要访问的路径
    const redirectPath = to.fullPath
    return navigateTo(`/login?redirect=${encodeURIComponent(redirectPath)}`, { replace: true })
  }
})
